import { TextField, TextFieldProps } from "@mui/material";

export const INPUT_SX = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#e5e7eb",
      borderRadius: "6px",
    },
    "&:hover fieldset": {
      borderColor: "#d1d5db",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#39bdf8",
    },
  },
  "& input": {
    fontSize: "14px",
  },
  "& .MuiInputLabel-root": {
    fontSize: "14px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#39bdf8",
  },
  "& .MuiSelect-select": {
    fontSize: "14px",
  },
} as const;

export function FormTextField(props: TextFieldProps) {
  return <TextField fullWidth size="small" sx={INPUT_SX} {...props} />;
}
